import { Asset } from 'app/shared/collections/asset';
import { IpDevice } from 'app/shared/collections/ip_device';
import { FieldSchemaUnits } from 'app/shared/collections/StatDefinition';
import { Zone } from 'app/shared/collections/zones/zone';
import { IMSAggregator } from 'app/views/aggregators/aggregator';
import { IMSValueGetter, StatFilterFnGenerator } from 'app/views/value_getters/value_getter';

// This class is designed to get values from IMS Objects that aren't time-related such as Assets, Zones and IP Devices
export class ImsObjectValueGetter extends IMSValueGetter {
    constructor(
        statKey: string, // The value key name to access on IMS objects provided, eg 'name'
        units: FieldSchemaUnits = null,
        filterFunctionGenerator: StatFilterFnGenerator = null,
    ) {
        super(null, statKey, units, filterFunctionGenerator);
    }

    /**
     * Takes an Asset and a cesium time and returns a value from the provided Asset object using the statKey
     *
     * @param asset An Asset object (IMS Asset, not Cesium Entity)
     * @param time Cesium JulianDate object
     * @param aggregator IMSAggregator
     * @returns a number or string value
     */
    getValueForAsset(asset: Asset, time: Cesium.JulianDate, aggregator: IMSAggregator = null) {
        return asset[this.statKey];
    }

    /**
     * Takes an IP Device and a cesium time and returns a value from the provided IPDevice object using the statKey
     *
     * @param ipDevice An IMS IpDevice object
     * @param time Cesium JulianDate object
     * @param aggregator IMSAggregator
     * @returns a number or string value
     */
    getValueForIPDevice(
        ipDevice: IpDevice,
        time: Cesium.JulianDate,
        aggregator: IMSAggregator = null,
    ) {
        return ipDevice[this.statKey];
    }

    /**
     * Takes a Zone and a cesium time and returns a value from the provided Zone object using the statKey
     *
     * @param zone An IMS Zone object
     * @param time Cesium JulianDate object
     * @param aggregator IMSAggregator
     * @returns a number or string value
     */
    getValueForZone(zone: Zone, time: Cesium.JulianDate, aggregator: IMSAggregator = null) {
        return zone[this.statKey];
    }
}
